import React__default from 'react';
import { sameType } from '../../utils/react.js';

/* eslint-disable no-restricted-syntax */
// utilities comuni ai componenti "tabelle".
/**
 * Verifica se a qualche livello dei children esiste un componente di tipo ColumnComponent con larghezza fissa.
 * @param children children di un componente.
 * @param ColumnComponent component column
 * su cui cercare le proprietà che caratterizzano una colonna di larchezza fissa.
 * @returns true se a qualche livello esiste un componente di tipo ColumnComponent con larghezza fissa.
 */
function existFixedColumns(children, ColumnComponent) {
    var _a;
    const myChildren = React__default.Children.toArray(children).filter((child) => child);
    for (const comp of myChildren) {
        if (sameType(comp, ColumnComponent)) {
            if ((_a = comp.props) === null || _a === void 0 ? void 0 : _a.width)
                return true;
        }
        if (React__default.isValidElement(comp) && comp.props.children) {
            if (existFixedColumns(comp.props.children, ColumnComponent))
                return true;
        }
    }
    return false;
}
/**
 * Carica dati da un data source.
 *
 * @param dataSource sorgente di dati.
 * Può essere una funzione, nel qual caso la lista di ritorno è passara alla callback, o un array di oggetti.
 * @param callback callback.
 * @param props se specifico delle proprietà,
 * significa che datasource è una funzione in grado di gestire pageSize, currentPage, sortProperty, sortOrder, filtri.
 * @returns l'oggetto di ritorno avrà Items che è una array con i valori e Count con il numero totale degli oggetti.
 */
function loadDataSource(dataSource, callback, props) {
    const { pageSize, currentPage, sortProperty, sortOrder, filtri, } = props;
    if (dataSource && typeof (dataSource) === 'function') {
        const filteredResult = dataSource(pageSize, currentPage ? currentPage * pageSize : 0, sortProperty, sortOrder, filtri);
        // verifico se mi viene ritornata una promise
        if (filteredResult.then && typeof filteredResult.then === 'function') {
            filteredResult.then((results) => {
                callback(results, props);
            });
        }
        else {
            callback(filteredResult, props);
        }
    }
    /*
    if (dataSource && Array.isArray(dataSource)) {
      callback({ Items: dataSource, Count: dataSource.length }, props);
    }
    */
    // caso non gestito, non chiamo la callback
}

export { existFixedColumns, loadDataSource };
